import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { IonicModule } from '@ionic/angular/lazy';
import { CashTrackingEndTrackingPage } from 'src/app/modals/cash-tracking-end-tracking/cash-tracking-end-tracking.page';

const routes: Routes = [
  {
    path: '',
    component: CashTrackingEndTrackingPage
  }
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    FontAwesomeModule,
    RouterModule.forChild(routes)
  ],
  declarations: [CashTrackingEndTrackingPage]
})
export class CashTrackingEndTrackingPageModule {}
